import { takeEvery, put, call } from "redux-saga/effects"

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, ON_GET_CAPTCHA } from "./actionTypes"
import { loginSuccess, apiError, onGetCaptchaSuccess, onGetCaptchaFail } from "./actions"
import { ROUTER_GROUP } from "helpers/router_helper"

import {
  postJwtLogin,
  getCaptcha,
} from "helpers/backend_helper"

import { isEmpty } from "lodash"

function* loginUser({ payload: { user, history } }) {
  console.log("inside login user saga 123jk")
  console.log(user)
  try {
    const response = yield call(postJwtLogin, {
      username: user.username,
      password: user.password,
      groupCode: user.groupCode,
      userType: user.userType,
      userCaptcha: user.userCaptcha,
      captchaToken: user.captchaToken
    })
    console.log("Response::::" + JSON.stringify(response))
    yield put(loginSuccess(response))
    sessionStorage.setItem("authUser", JSON.stringify(response))
    localStorage.setItem("authUser", sessionStorage.getItem("authUser"))
    let isAdmin = false;
    let isUser = false;
    let isGRPGroupAdmin = false;
    let isGRPBranchAdmin = false;
    let isGRPGroupUser = false;
    let roleDescription = '';
    console.log("Response::::" + JSON.stringify(response))
    if (response !== undefined && !isEmpty(response.username)) {
      let username = response.username
      sessionStorage.setItem("loginUserName", username);
      console.log("username from jk::::" + username);
    }
    if (response !== undefined && !isEmpty(response.authorities)) {
      let authority = response.authorities[0].authority
      console.log(authority)
      if (authority === 'ROLE_ASTRO_REPORTUSER') {
        isUser = true;
        roleDescription = "Kattam User "
      } else if (authority === 'ROLE_GRP_GROUP_ADMIN') {
        isGRPGroupAdmin = true;
        roleDescription = "Group Administrator"
      } else if (authority === 'ROLE_GRP_BRANCH_ADMIN') {
        isGRPBranchAdmin = true;
        roleDescription = "Branch Administrator"
      } else if (authority === 'ROLE_GRP_GROUP_USER') {
        isGRPGroupUser = true;
        roleDescription = "User"
      }
    }
    sessionStorage.setItem("userDashboardRole", JSON.stringify({
      role: response.authorities[0].authority,
      roleDescription: roleDescription,
    }));
    sessionStorage.setItem("userRoles", JSON.stringify({
      productAdmin: isAdmin,
      user: isUser,
      isGRPGroupAdmin, isGRPBranchAdmin, isGRPGroupUser
    }));

    localStorage.setItem("userDashboardRole",sessionStorage.getItem("userDashboardRole"));
    localStorage.setItem("userRoles",sessionStorage.getItem("userRoles"));
    
    console.log("login selection based on the role")
    if (isGRPGroupAdmin || isGRPBranchAdmin || isGRPGroupUser) {
      history.push(ROUTER_GROUP + "/dashboard")
    } else {
      history.push("/dashboard")
    }
  } catch (error) {
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      if (isEmpty(error.response.data.message)) {
        yield put(apiError(error.response.data))
      } else {
        yield put(apiError(error.response.data.message))
      }
    } else {
      yield put(apiError(error.message))
    }
  }
}

function* getCaptchaSaga() {
  console.log("getCaptchaSaga()->called")
  try {
    const response = yield call(getCaptcha)
    console.log(response)
    yield put(onGetCaptchaSuccess(response))
  } catch (error) {
    console.log(error)
    yield put(onGetCaptchaFail(error))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    let userRoles = {
      user: false,
      productAdmin: false,
      isGRPGroupAdmin: false,
      isGRPBranchAdmin: false,
      isGRPGroupUser: false
    }
    if (sessionStorage.getItem("userRoles")) {
      let savedUserRoles = JSON.parse(sessionStorage.getItem("userRoles"));
      if (savedUserRoles !== undefined) {
        userRoles = savedUserRoles;
      }
    }

    sessionStorage.removeItem("authUser")
    sessionStorage.removeItem("userProfile")
    sessionStorage.removeItem("userDashboard")
    localStorage.removeItem("authUser")
    localStorage.removeItem("userProfile")
    localStorage.removeItem("userDashboard")


    if (userRoles.user) {
      history.push("/login")
    } else if (userRoles.productAdmin) {
      history.push("/product/login")
    } else if (userRoles.isGRPGroupAdmin || userRoles.isGRPBranchAdmin || userRoles.isGRPGroupUser) {
      history.push(ROUTER_GROUP + "/login")
    }
  } catch (error) {
    yield put(apiError(error))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeEvery(LOGOUT_USER, logoutUser)
  yield takeEvery(ON_GET_CAPTCHA, getCaptchaSaga)
}

export default authSaga
